import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Footer from "@components/Footer";
import Header from "@components/Header";

import { useGetTerms } from "@api/terms";

import { ETermType } from "@schemas/terms";

import { useTermsStore } from "@stores/termStore";
import "./style.scss";

export default function DefaultLayout() {
	const { setTerms, terms } = useTermsStore(["setTerms", "terms"]);
	const location = useLocation();
	const { data: termsRes } = useGetTerms(
		[ETermType.TERMS_OF_SERVICE, ETermType.PRIVACY_POLICY, ETermType.MARKETING_CONSENT],
		{
			enabled: !terms,
		},
	);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	useEffect(() => {
		if (termsRes?.data?.terms) {
			setTerms(termsRes.data.terms);
		}
	}, [termsRes]);
	return (
		<div className="layout-root">
			<Header />
			<div className="layout-content">
				<Outlet />
			</div>
			<Footer />
		</div>
	);
}
